import type { CouponIdentifiers } from '../../../../schema/coupon/entry.js';
import type { IGetCouponUseCase } from '../../../domain/entry.js';

export type IGetCouponController = ReturnType<typeof getCouponController>;

/**
 * Controller for subscribe to a coupon model.
 *
 * @param subscribeCouponUseCase Use case for subscribing to a coupon model
 * @returns Controller executor function
 */
export function getCouponController(subscribeCouponUseCase: IGetCouponUseCase) {
  return function controller({ couponId, couponIndex }: CouponIdentifiers): ReturnType<IGetCouponUseCase['execute']> {
    return subscribeCouponUseCase.execute({ couponId, couponIndex });
  };
}
